(function () {
	// Each slide now holds a different message, so slides vary in width. Swiper
	// gives every slide the same transition duration, which would make short
	// messages crawl and long ones race past; instead scroll every slide at the
	// pixel rate implied by the merchant's speed setting.
	const setSlideDuration = (swiper) => {
		const pixelsPerMs = swiper.announcementPixelsPerMs;
		if (!pixelsPerMs) return;
		const slide = swiper.slides[swiper.activeIndex];
		if (!slide || !slide.offsetWidth) return;
		swiper.params.speed = slide.offsetWidth / pixelsPerMs;
	};

	const announcementSlider = () => {
		$(".announcement-bar__slide").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			if($(".announcement-bar").hasClass("announcement__slide-show")){
				$(this).addClass("slider_started");
			}
			const announcementId = $(this).data("announcement-id");
			const announcementSpeed = $(this).data("announcement-speed") * 1000;
			const announcementSwiper = new Swiper(
				`.announcement-js-${announcementId}`,
				{
					slidesPerView: "auto",
					speed: announcementSpeed,
					initialSlide: 0,
					loop: true,
					loopedSlides: 50,
					allowTouchMove: true,
					waitForTransition: false,
					watchSlidesProgress: false,
					autoplay: {
						delay: 0,
						disableOnInteraction: false,
					},
					on: {
						afterInit(swiper) {
							// Rate is set from the average slide, so a message still takes
							// the configured time on average however long each one is.
							let totalWidth = 0;
							for (let i = 0; i < swiper.slides.length; i += 1) {
								totalWidth += swiper.slides[i].offsetWidth;
							}
							const averageWidth = totalWidth / swiper.slides.length;
							if (announcementSpeed > 0 && averageWidth) {
								swiper.announcementPixelsPerMs = averageWidth / announcementSpeed;
							}
							setSlideDuration(swiper);
						},
						slideChangeTransitionStart(swiper) {
							setSlideDuration(swiper);
						},
					},
				}
			);
		});
	};
	checkWindow();
	$(window).resize(function () {
		checkWindow();
	});
	announcementSlider();
	document.addEventListener("shopify:section:load", function () {
		announcementSlider();
	});

	document.addEventListener("visibilitychange", function () {
		if (!document.hidden) {
			$(".announcement-js").each(function () {
				this.swiper.destroy();
			});
			announcementSlider();
		}
	});

	function checkWindow() {
		if ($(window).width() < 576) {
			$(".announcement-bar").addClass("announcement__slide-show");
			announcementSlider();
		} else {
			$(".announcement-bar__slide").removeClass("slider_started");
			$(".announcement-bar").removeClass("announcement__slide-show");
		}
	}
})();
